import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";

import Phone from "../phone";
import AddressRow from "../addressRow";
import preselections from "../phone/preselections.json";
import InputItem from "../../../../app/generic/form/inputItem";

export const parseContactForm = (values, inputId = "") => ({
  name: values[`contactPerson${inputId}`],
  firstName: values[`contactPersonFirstName${inputId}`],
  lastName: values[`contactPersonLastName${inputId}`],
  email: values[`contactEmail${inputId}`],
  preselection: values[`contactPhonePreselection${inputId}`],
  phone: values[`contactPhone${inputId}`],
});

export const parseInitialContactValues = (principal, inputId = "") => {
  const values = getDefaultContactForm(inputId);
  if (principal) {
    values[`contactPerson${inputId}`] = principal.name;
    values[`contactPersonFirstName${inputId}`] = principal.firstName;
    values[`contactPersonLastName${inputId}`] = principal.lastName;
    values[`contactEmail${inputId}`] = principal.email;
    values[`contactPhonePreselection${inputId}`] =
      principal.preselection || preselections[0].code;
    values[`contactPhone${inputId}`] = principal.phone;
  }
  return values;
};

export const getDefaultContactForm = (inputId = "") => {
  const values = {};
  values[`contactPhonePreselection${inputId}`] = preselections[0].code;
  return values;
};

const Contact = ({
  form,
  emailLabel,
  phoneLabel,
  onPhoneBlur,
  emailMessage,
  phoneMessage,
  contactLabel,
  inputId = "",
  emailRequired,
  phoneRequired,
  contactMessage,
  formItemLayout,
  disabledPerson,
  contactRequired,
  separateContact,
  showContact = true,
  initialPreselection,
  onPreselectionSelect,
  onContactPersonChange,
  showContactPerson = true,
}) => {
  const handleContactSet = useCallback(
    (firstName, lastName) => {
      onContactPersonChange &&
        onContactPersonChange(
          firstName && lastName
            ? `${firstName} ${lastName}`
            : firstName || lastName
        );
    },
    [onContactPersonChange]
  );

  const handleContactChange = useCallback(
    ({ target }) => {
      handleContactSet(target.value);
    },
    [handleContactSet]
  );

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleFirstNameChange = useCallback(
    ({ target }) => {
      handleContactSet(target.value, lastName);
      setFirstName(target.value);
    },
    [lastName, handleContactSet]
  );
  const handleLastNameChange = useCallback(
    ({ target }) => {
      handleContactSet(firstName, target.value);
      setLastName(target.value);
    },
    [firstName, handleContactSet]
  );

  return (
    <>
      {showContactPerson &&
        (separateContact ? (
          <AddressRow
            equal
            firstChildren={
              <InputItem
                disabled={disabledPerson}
                required={contactRequired}
                formItemLayout={formItemLayout}
                onChange={handleFirstNameChange}
                fieldName={`contactPersonFirstName${inputId}`}
                label={
                  <FormattedMessage
                    id="address.contactPerson.firstName"
                    defaultMessage="Jméno"
                  />
                }
                message={
                  <FormattedMessage
                    id="address.contactPerson.firstName.empty"
                    defaultMessage="Zadejte prosím jméno!"
                  />
                }
              />
            }
            secondChildren={
              <InputItem
                disabled={disabledPerson}
                required={contactRequired}
                formItemLayout={formItemLayout}
                onChange={handleLastNameChange}
                fieldName={`contactPersonLastName${inputId}`}
                label={
                  <FormattedMessage
                    id="address.contactPerson.lastName"
                    defaultMessage="Příjmení"
                  />
                }
                message={
                  <FormattedMessage
                    id="address.contactPerson.lastName.empty"
                    defaultMessage="Zadejte prosím příjmení!"
                  />
                }
              />
            }
          />
        ) : (
          <InputItem
            required={contactRequired}
            onChange={handleContactChange}
            formItemLayout={formItemLayout}
            fieldName={`contactPerson${inputId}`}
            label={
              contactLabel || (
                <FormattedMessage
                  id="address.contactPerson"
                  defaultMessage="Kontaktní osoba"
                />
              )
            }
            message={
              contactMessage || (
                <FormattedMessage
                  id="address.contactPerson.empty"
                  defaultMessage="Zadejte prosím kontaktní osobu!"
                />
              )
            }
          />
        ))}
      {showContact && (
        <AddressRow
          equal
          firstChildren={
            <Phone
              form={form}
              inputId={inputId}
              label={phoneLabel}
              message={phoneMessage}
              required={phoneRequired}
              onPhoneBlur={onPhoneBlur}
              initialPreselection={initialPreselection}
              onPreselectionSelect={onPreselectionSelect}
            />
          }
          secondChildren={
            <InputItem
              email
              autoComplete="email"
              required={emailRequired}
              formItemLayout={formItemLayout}
              fieldName={`contactEmail${inputId}`}
              label={
                emailLabel || (
                  <FormattedMessage
                    id="address.contactEmail"
                    defaultMessage="Email"
                  />
                )
              }
              message={
                emailMessage || (
                  <FormattedMessage
                    id="address.contactEmail.empty"
                    defaultMessage="Zadejte prosím emailový kontakt!"
                  />
                )
              }
            />
          }
        />
      )}
    </>
  );
};

export default Contact;
